/* eslint-disable no-unused-vars */
enum Alignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}

export default Alignment;
